module.exports = __webpack_public_path__ + "static/assets/a2b18bcce350f3920e53e1a294ed58f7.gif";